import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs';
import {CreditorKey} from "@pma-entity/pma-entity-types";
import {MfsAllowListDataService} from "@mfs/default-dashboard/services/mfs-allow-list-data.service";

/**
 * Ensures the requested dashboard is within the user's allow lists.
 *
 * N.B. using client side lists to do this isn't 'proper' app security of
 * course, so individual API end points perform server side checks too.
 *
 * However, redirecting the user if an invalid URL is requested provides
 * both semblance of data protection as well as the required UX to inform
 * the user in case a bookmark for a different login was used by mistake.
 *
 * No information/distinction is supplied to indicate an entity that exists
 * and is not permitted (401) vs an entity that does not exist at all (404).
 * Both are classes here as 'invalid' (400).
 */
@Injectable({
  providedIn: 'root',
})
export class MfsInvalidEntityRouteGuard {

  constructor(
    private readonly router: Router,
    private readonly allowListProvider: MfsAllowListDataService) {}

  canActivate(route: ActivatedRouteSnapshot,
              state: RouterStateSnapshot): Observable<boolean> {

    const creditorUri = route.params['accountId'];

    return this.allowListProvider.getForCurrentUser().pipe(
      map(mfsAllowLists => {
        let isValid = false;
        if (creditorUri !== undefined) {
          isValid = mfsAllowLists?.AllowedCreditors?.some((key: CreditorKey) => key.Uri == creditorUri);
        }
        if (isValid) {
          return true;
        } else {
          this.router.navigate(['/invalid-entity'],
            { queryParams: { 'previouslyRequestedUrl': state.url } });
          return false;
        }
      })
    );
  }

}
